module.exports = __webpack_public_path__ + "img/compare-blank.15805953.svg";